import '.eg{font-size:1.125rem;}.ssr-plugin'
import '.eh{line-height:1.75rem;}.ssr-plugin'
import '.hi{text-decoration:none;}.ssr-plugin'
import '.ft{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="eg eh"
    >
      {translations.privacySubtitle}{' '}
      <a className="hi ft"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="hi ft"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
